import { render } from "./MenuLevel2.vue?vue&type=template&id=000a9d40&ts=true"
import script from "./MenuLevel2.vue?vue&type=script&lang=ts"
export * from "./MenuLevel2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__